<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import long2ip from 'locutus/php/network/long2ip'
import PageNavigation from '@components/admin/page-navigation'
import { fetchRealnameList } from '@apis/admin/kyc'
import fromPairs from 'lodash/fromPairs'
import strtotime from 'locutus/php/datetime/strtotime'
import map from 'lodash/map'
import mapKeys from 'lodash/mapKeys'
import pick from 'lodash/pick'

export default {
  components: { PageNavigation },
  data() {
    return {
      loading: false,
      list: [],
      total_count: 0,
      page: 1,
      total_page: 0,
      page_navigation: {},
      search_params: {},
      s_realname_seq: 0,
      show_dialog: false,
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('kyc_realname_list.kyc_realname_list'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today') * 1000),
                new Date(strtotime('tomorrow') * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_yesterday'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('yesterday') * 1000),
                new Date(strtotime('today') * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_thismonth'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(
                  strtotime('today', strtotime('first day of this month')) *
                    1000
                ),
                new Date(
                  strtotime('today', strtotime('first day of next month')) *
                    1000 -
                    1
                ),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_lastmonth'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(
                  strtotime('today', strtotime('first day of last month')) *
                    1000
                ),
                new Date(
                  strtotime('today', strtotime('first day of this month')) *
                    1000 -
                    1
                ),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_thisweek'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today', strtotime('this week')) * 1000),
                new Date(strtotime('today', strtotime('next week')) * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_lastweek'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today', strtotime('last week')) * 1000),
                new Date(strtotime('today', strtotime('this week')) * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_week'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('-7 day') * 1000),
                new Date(),
              ])
            },
          },
          {
            text: this.$t('kyc_realname_list.shortcuts_month'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('-30 day') * 1000),
                new Date(),
              ])
            },
          },
        ],
      },
      excel_headers: [
        ['seq', this.$t('kyc_realname_list.seq')],
        ['member_seq', this.$t('kyc_realname_list.member_seq')],
        ['user_id', this.$t('kyc_realname_list.user_id')],
        ['user_name', this.$t('kyc_realname_list.user_name')],
        ['authority', this.$t('kyc_realname_list.authority')],
        ['name', this.$t('kyc_realname_list.name')],
        ['sex', this.$t('kyc_realname_list.sex')],
        ['nationality', this.$t('kyc_realname_list.nationality')],
        ['birth_date', this.$t('kyc_realname_list.birth_date')],
        ['di', this.$t('kyc_realname_list.di')],
        ['ci', this.$t('kyc_realname_list.ci')],
        ['cell_carrier', this.$t('kyc_realname_list.cell_carrier')],
        ['cell_number', this.$t('kyc_realname_list.cell_number')],
        ['status', this.$t('kyc_realname_list.status')],
        ['is_valid', this.$t('kyc_realname_list.is_valid')],
        ['closed_date', this.$t('kyc_realname_list.closed_date')],
        ['expdate', this.$t('kyc_realname_list.expdate')],
        ['ipaddress', this.$t('kyc_realname_list.ipaddress')],
        ['regdate', this.$t('kyc_realname_list.regdate')],
      ],
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
    c_regdate_range: {
      get() {
        const regdate_start = this.search_params.regdate_start || ''
        const regdate_end = this.search_params.regdate_end || ''
        return [
          regdate_start ? new Date(regdate_start * 1) : '',
          regdate_end ? new Date(regdate_end * 1) : '',
        ]
      },
      set([start, end]) {
        this.$set(
          this.search_params,
          'regdate_start',
          start ? `${start.getTime()}` : undefined
        )
        this.$set(
          this.search_params,
          'regdate_end',
          end ? `${end.getTime()}` : undefined
        )
      },
    },
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      this.search_params = { ...this.$route.query }
      Promise.all([this.loadList()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchRealnameList({
        ...this.$route.params,
        ...this.$route.query,
      })

      this.list = ret_obj.data
      this.total_count = ret_obj.total_count
      this.total_page = ret_obj.total_page
      this.page_navigation = ret_obj.page_navigation
    },
    search() {
      this.$router.push({ query: this.search_params })
    },
    clearAndSearch() {
      this.search_params = {}
      this.search()
    },
    async handleExportExcel() {
      this.loading = true
      try {
        if (
          !(await this.$confirm(
            this.$t('kyc_realname_list.msg_server_overload'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        const { data } = await fetchRealnameList({
          ...this.$route.params,
          ...this.$route.query,
          no_paging: 1,
        })

        const { default: exportJsonToExcel } = await import(
          '@utils/export-json-to-excel'
        )
        exportJsonToExcel({
          header: map(this.excel_headers, ([, title]) => title),
          data: this.format2excel(data),
          filename: this.$t('kyc_realname_list.real_name', [date('YmdHis')]),
        })
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    format2excel(list) {
      const excel_fields = map(this.excel_headers, ([name]) => name)
      return map(list, (data) => {
        let result = pick(data, excel_fields)
        const keys = Object.keys(result)
        result = mapKeys(
          map(result, (val, key) => {
            switch (key) {
              case 'authority':
                return fromPairs(this.constants.kyc.realname.authority)[val]
              case 'status':
                return fromPairs(this.constants.kyc.realname.status)[val]
              case 'nationality':
                return fromPairs(this.constants.kyc.realname.nationality)[val]
              case 'sex':
                return fromPairs(this.constants.kyc.realname.sex)[val]
              case 'regdate':
                return val ? date('Y-m-d H:i:s', new Date(val)) : ''
              default:
                return val
            }
          }),
          (val, key) => {
            return keys[key]
          }
        )

        return map(excel_fields, (key) => result[key])
      })
    },
    date,
    fromPairs,
    long2ip,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{ $t('admin.search') }}</h3>
    <form @submit.prevent="search">
      <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
        <colgroup>
          <col width="20%" />
          <col width="30%" />
          <col width="20%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="4">
              <el-date-picker
                v-model="c_regdate_range"
                :class="$style.fr"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="right"
              >
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <th scope="col">
              <div>
                <select
                  v-model="search_params.search_target"
                  :class="$style.fullWidth"
                >
                  <option
                    v-for="val in [
                      [undefined, $t('admin.search_target')],
                      ['user_id', $t('admin.user_id')],
                      ['email_address', $t('admin.email_address')],
                      ['user_name', $t('admin.user_name')],
                      ['name', $t('admin.real_name')],
                      ['di', $t('admin.di')],
                      ['ci', $t('admin.ci')],
                      ['regdate_more', $t('admin.login_log_regdate_more')],
                      ['regdate_less', $t('admin.login_log_regdate_less')],
                    ]"
                    :key="val[1]"
                    :value="val[0]"
                    >{{ val[1] }}</option
                  >
                </select>
              </div>
            </th>
            <td>
              <input
                v-model="search_params.search_keyword"
                :placeholder="$t('admin.search_word')"
                type="text"
                :class="[$style.inputTypeText, $style.fullWidth]"
              />
            </td>
            <td colspan="2">
              <ElCheckbox
                v-model="search_params.use_statistics_exclude"
                :false-label="undefined"
                true-label="N"
                >{{
                  $t('kyc_realname_list.statistics_exclude_members')
                }}</ElCheckbox
              >
              <ElCheckbox
                v-model="search_params.member_is_alive"
                :false-label="undefined"
                true-label="Y"
                >{{
                  $t('kyc_realname_list.withdrawal_members_excluded')
                }}</ElCheckbox
              >
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.status') }}</div></th
            >
            <td>
              <ElRadioGroup v-model="search_params.status" size="mini">
                <ElRadioButton
                  v-for="val in [
                    [undefined, $t('admin.total')],
                    ...constants.kyc.realname.status,
                  ]"
                  :key="val[0]"
                  :label="val[0]"
                  >{{ val[1] }}</ElRadioButton
                >
              </ElRadioGroup>
            </td>
            <th scope="col"
              ><div>{{ $t('admin.nationality') }}</div></th
            >
            <td>
              <ElRadioGroup v-model="search_params.nationality" size="mini">
                <ElRadioButton
                  v-for="val in [
                    [undefined, $t('admin.total')],
                    ...constants.kyc.realname.nationality,
                  ]"
                  :key="val[0]"
                  :label="val[0]"
                  >{{ val[1] }}</ElRadioButton
                >
              </ElRadioGroup>
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.search_is_valid') }}</div></th
            >
            <td>
              <el-checkbox
                v-model="search_params.is_valid"
                true-label="Y"
                :false-label="undefined"
                >{{ $t('admin.yes') }}</el-checkbox
              >
            </td>
            <th scope="col"
              ><div>{{ $t('admin.sort') }}</div></th
            >
            <td>
              <select v-model="search_params.sort_order">
                <option
                  v-for="val in [[undefined, $t('admin.regdate')]]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
              <select v-model="search_params.order_type">
                <option
                  v-for="val in [
                    [undefined, $t('admin.desc')],
                    ['asc', $t('admin.asc')],
                  ]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th colspan="4" :class="$style.button">
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="clearAndSearch"
                ><span>{{ $t('admin.reset') }}</span></a
              >
              {{ ' ' }}
              <span :class="[$style.button, $style.black]"
                ><input type="submit" :value="$t('admin.submit')"
              /></span>
            </th>
          </tr>
        </tbody>
      </table>
    </form>
    <h3 :class="$style.xeAdmin">{{ $t('admin.real_name_list') }}</h3>
    <fieldset :class="$style.clearfix">
      <div :class="$style.fl">
        <a href="#" :class="[$style.button]" @click.prevent="handleExportExcel"
          ><span>{{ $t('admin.excel_download') }}</span></a
        >
      </div>
    </fieldset>
    <table cellspacing="0" cellpadding="0" :class="$style.colTable">
      <caption v-if="!loading"
        >Total {{ total_count }}, Page {{ page }}/{{ total_page }}</caption
      >
      <thead>
        <tr>
          <th scope="col" rowspan="2"
            ><div
              ><a href="#">{{ $t('admin.num') }}</a></div
            ></th
          >
          <template v-if="!$route.params.member_seq">
            <th scope="col" :class="$style.quarter_wide"
              ><div>{{ $t('admin.user_id') }}</div></th
            >
            <th scope="col" :class="$style.quarter_wide"
              ><div>{{ $t('admin.user_name') }}</div></th
            >
          </template>
          <th scope="col"
            ><div>{{ $t('admin.authority') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.real_name') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin_member_list.birthday') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.di') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.cell_carrier') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.status') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.close_date') }}</div></th
          >
          <th scope="col" rowspan="2"
            ><div>{{ $t('admin.regdate') }}</div></th
          >
          <th scope="col" rowspan="2"><div>&nbsp;</div></th>
        </tr>
        <tr>
          <template v-if="!$route.params.member_seq">
            <th scope="col" colspan="2" :class="$style.quarter_wide"
              ><div>{{ $t('admin.email_address') }}</div></th
            >
          </template>
          <th scope="col"
            ><div>{{ $t('admin.nationality') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.sex') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.ip_address') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.ci') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.cell_number') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.kyc_is_valid') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.kyc_expdate') }}</div></th
          >
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, idx) in list">
          <tr :key="`1-${data.seq}`" :class="$style[`bg${idx % 2}`]">
            <td rowspan="2" :class="[$style.tCenter, $style.nowrap]">{{
              data._no
            }}</td>
            <template v-if="!$route.params.member_seq">
              <td :class="[$style.tCenter, $style.nowrap]">{{
                data.user_id
              }}</td>
              <td :class="[$style.tCenter, $style.nowrap]">{{
                data.user_name
              }}</td>
            </template>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.kyc.realname.authority)[data.authority]
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{ data.name }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              date('Y-m-d', new Date(data.birth_date))
            }}</td>
            <td :class="[$style.wide]">{{ data.di }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              data.cell_carrier
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.kyc.realname.status)[data.status]
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              data.closed_date === null
                ? $t('admin.no_close')
                : date('Y-m-d H:i:s', new Date(data.closed_date))
            }}</td>
            <td rowspan="2" :class="[$style.tCenter, $style.nowrap]">{{
              date('Y-m-d H:i:s', new Date(data.regdate))
            }}</td>
            <td rowspan="2" :class="$style.tCenter"> </td>
          </tr>
          <tr :key="`2-${data.seq}`" :class="$style[`bg${idx % 2}`]">
            <template v-if="!$route.params.member_seq">
              <td colspan="2" :class="[$style.nowrap]">{{
                data.email_address
              }}</td>
            </template>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.kyc.realname.nationality)[data.nationality]
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.kyc.realname.sex)[data.sex]
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              long2ip(data.ipaddress)
            }}</td>
            <td :class="[$style.wide]">{{ data.ci }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              data.cell_number
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              data.is_valid === 'Y' ? $t('admin.valid') : $t('admin.invalid')
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              data.expdate === null
                ? $t('admin.no_appoint')
                : date('Y-m-d H:i:s', new Date(data.expdate))
            }}</td>
          </tr>
        </template>
        <tr v-if="loading">
          <td
            :colspan="$route.params.member_seq ? 10 : 12"
            :class="$style.tCenter"
            >{{ $t('admin.loading') }}</td
          >
        </tr>
        <tr v-else-if="!list.length">
          <td
            :colspan="$route.params.member_seq ? 10 : 12"
            :class="$style.tCenter"
            >{{ $t('admin.no_search_real_name') }}</td
          >
        </tr>
      </tbody>
    </table>
    <PageNavigation
      v-if="!loading"
      :total_count="total_count"
      :total_page="page_navigation.total_page"
      :cur_page="page"
      :page_count="page_navigation.page_count"
    ></PageNavigation>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
</style>
